import { Component, OnInit ,Input, Output, EventEmitter,AfterViewInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment'; 
declare let $ : any;
@Component({
  selector: 'app-procurement',
  templateUrl: './procurement.component.html',
  styleUrls: ['./procurement.component.css']
})
export class ProcurementComponent implements OnInit, AfterViewInit {
  @Input() parames:any;
  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute) { }

  ngOnInit(): void {
    //console.log(this.parames);
    this.getPageContent(this.parames.mainmenuid,'mainmenu_content');
  }
 
  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }

  backendUrl = environment.serviceURL;

  content_apiresponse:any;
  PageContent:any;
    getPageContent(mainmenuid:any,type:any) {
      //console.log(mainmenuid,type);
      var params;
      if(type=='mainmenu_content'){
        params = [{
          "secSlNo":1,
            "offSet":0,
            "noOfRecords":0,
            "orderBy":[{"columnName":"intId","type":"DESC"}],
            "condition":[
                {"columnName":"VCHPAGEALIAS","operator":"=","value":mainmenuid,"joinoperator":"and"},
                {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
                {"columnName":"tinPublishStatus","operator":"=","value":1,"joinoperator":"and"}
                ],
            "viewParameters":""
        }];
      } else if(type=='innermenu_content'){
        params = [{
          "secSlNo":1,
            "offSet":0,
            "noOfRecords":0,
            "orderBy":[{"columnName":"intId","type":"DESC"}],
            "condition":[
                {"columnName":"INNER_PAGE_ALIAS","operator":"=","value":mainmenuid,"joinoperator":"and"},
                {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
                {"columnName":"tinPublishStatus","operator":"=","value":1,"joinoperator":"and"}
                ],
            "viewParameters":""
        }];
      } else {
        return;
      }
      this.fciwebservice.getpageContent(params).subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            //console.log('Sent' + HttpEventType.Sent);
            break;
          case HttpEventType.ResponseHeader:
            //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
            break;
          case HttpEventType.UploadProgress:
            //this.evenTotal = response.total;
            //this.progress = Math.round(response.loaded / this.evenTotal * 100);
            break;
          case HttpEventType.Response:
            this.content_apiresponse = response.body;
            this.PageContent = this.content_apiresponse.result.sec_1;
        }
      });
    }
  

}
